import { makeAutoObservable } from "mobx";

export class UiStore {
  isMobile = false;

  chatHeaderHeight = 0;

  private _focusMessageTextareaCallback: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setIsMobile(value: boolean) {
    this.isMobile = value;
  }

  setChatHeaderHeight(height: number) {
    this.chatHeaderHeight = height;
  }

  setFocusMessageTextareaCallback(cb: (() => void) | null) {
    this._focusMessageTextareaCallback = cb;
  }

  focusMessageTextarea() {
    this._focusMessageTextareaCallback?.();
  }
}
